import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./SubmitApplication.module.scss";
import { ATMGrid } from "components/atoms/ATMGrid/ATMGrid.component";
import { ATMSegment } from "components/atoms/ATMSegment/ATMSegment.component";
import { ATMButton } from "components/atoms/ATMButton/ATMButton.component";
import { useApplicationData } from "contexts/ApplicationDataContext";

interface SubmitApplicationProps {
    viewContext?: 'application' | 'review';
    /** Supplied by the application page so it can validate before navigating. */
    onNext?: () => void;
}

const SubmitApplication: React.FC<SubmitApplicationProps> = ({ viewContext = 'application', onNext }) => {
    const navigate = useNavigate();
    const { checkedTermsAndConditions } = useApplicationData();

    const handleNext = () => {
        if (onNext) {
            onNext();
            return;
        }
        navigate('/reviewAndSubmit');
    };

    const handleEdit = () => {
        navigate('/');
    };

    const handleSubmit = () => {
        // TODO: call submit API
    };

    const handleClear = () => {
        // TODO: reset application data
    };

    return (
        <ATMSegment size="tiny" className={styles.commonMargin}>
            <ATMGrid>
                <ATMGrid.Row className={styles.actionButtons}>
                    <ATMGrid.Column computer={8} tablet={16} mobile={16}>
                        <ATMButton
                            secondary
                            content={viewContext === 'application' ? 'Clear' : 'Edit'}
                            disabled
                            //onClick={viewContext === 'application' ? handleClear : handleEdit}
                            size="tiny"
                            data-testid="exitButton"
                            icon={viewContext === 'review' ? 'left chevron' : undefined}
                            className={styles.exitButton}
                        />
                    </ATMGrid.Column>

                    <ATMGrid.Column computer={8} tablet={16} mobile={16}>
                        <ATMButton
                            content={viewContext === 'application' ? 'Next' : 'Submit'}
                            //disabled
                            onClick={viewContext === 'application' ? handleNext : handleSubmit}
                            size="tiny"
                            data-testid="reviewButton"
                            className={styles.reviewButton}
                            icon="right chevron"
                            labelPosition="right"
                        />
                    </ATMGrid.Column>
                </ATMGrid.Row>
            </ATMGrid>
        </ATMSegment>
    );
};

export default SubmitApplication;
